import { CAMPAIGN_STATUSES_RUNNING_OR_RUNNED, ICampaign, ICampaignFilters } from "campaign/model"
import { getCampaignCount, getCampaigns } from "campaign/tools/common"

export const getOrderCampaignCount = (orderId: number): Promise<number> =>
  getCampaignCount(getOrderCampaignsFilters(orderId))

export const getOrderCampaigns = (orderId: number): Promise<ICampaign[]> =>
  getCampaigns({ page: 0, pageSize: 1000 }, getOrderCampaignsFilters(orderId))

const getOrderCampaignsFilters = (orderId: number): ICampaignFilters => ({
  name: "",
  creationDate: { date: null, labelKey: "" },
  startEndPeriod: { startDate: null, endDate: null },
  advertiserIds: [],
  orderIds: [orderId],
  statuses: CAMPAIGN_STATUSES_RUNNING_OR_RUNNED.slice(),
  isForecast: false
})
